import { styled } from 'styled-components';

import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';
import ticketsImg from '@sorare/core/src/assets/rewards/tickets.png';
import { Coin } from '@sorare/core/src/atoms/icons/Coin';
import { CardBack } from '@sorare/core/src/components/card/Back';

const Box = styled.img`
  height: var(--quadruple-unit);
  &.limited {
    filter: sepia(1) hue-rotate(-10deg) saturate(3);
  }
  &.rare {
    filter: sepia(1) hue-rotate(-55deg) saturate(6);
  }
`;

const EmojiIcon = styled.div`
  font-size: var(--triple-unit);
`;

const TinyCardBack = styled(CardBack)`
  height: var(--quadruple-unit);
`;

export const prizePool = [
  {
    category: 'Experiences',
    prizes: [
      {
        count: 1,
        displayName: 'VIP All Star',
        displayName2: 'Package',
        icon: <EmojiIcon>👜</EmojiIcon>,
      },
      {
        count: 25,
        displayName: '2x Game Tickets',
        displayName2: 'Regular Season',
        icon: <Box src={ticketsImg} />,
      },
    ],
  },

  {
    category: '75 All Star Pro Cards',
    type: 'cards',
    prizes: [
      {
        count: 1,
        rarity: 'super_rare',
        displayName2: 'Super Rare Card',
        displayName: 'All Star Player',
        icon: (
          <TinyCardBack
            sport={Sport.BASEBALL}
            season="2024"
            rarity={Rarity.super_rare}
            tier={1}
          />
        ),
      },
      {
        count: 9,
        rarity: 'rare',
        displayName2: 'Rare Card',
        displayName: 'All Star Player',
        icon: (
          <TinyCardBack
            sport={Sport.BASEBALL}
            season="2024"
            rarity={Rarity.rare}
          />
        ),
      },
      {
        count: 65,
        rarity: 'limited',
        displayName2: 'Limited Card',
        displayName: 'All Star Player',
        icon: (
          <TinyCardBack
            sport={Sport.BASEBALL}
            season="2024"
            rarity={Rarity.limited}
          />
        ),
      },
    ],
  },
  {
    category: '100 Sorare Merch',
    prizes: [
      {
        count: 50,
        displayName: 'Hoodies',
        icon: <EmojiIcon>👕</EmojiIcon>,
      },
      {
        count: 50,
        displayName: 'Hats',
        icon: <EmojiIcon>🧢</EmojiIcon>,
      },
    ],
  },

  {
    category: '200 In-Game Items',
    prizes: [{ count: 200, displayName: '2,000 Coins', icon: <Coin /> }],
  },
];
